import React from 'react'

export const MinimalButton = ({ onClick, text }) => {
    return (
        <button
            onClick={onClick}
            className='bg-yellow-400 px-2 py-1 rounded-md transition ease-in-out hover:translate-y-1 hover:scale-105 duration-200'
        >
            {text}
        </button>
    )
}
